import type { ReactElement } from 'react';
import { Select } from '../../../icons';
import { FrameClassification } from '../../../icons/frame-classification';
import type { CUSTOM_TOOLS } from '../../constants';
import { TOOL } from '../../constants';
import { type ToolT } from '../../types';
import BrushConfig from '../annotations/brush/config/toolbar-config';
import CuboidConfig from '../annotations/cuboid/config/toolbar-config';
import EllipseConfig from '../annotations/ellipse/config/toolbar-config';
import KeyPointConfig from '../annotations/key-point/config/toolbar-config';
import PolygonConfig from '../annotations/polygon/config/toolbar-config';
import PolylineConfig from '../annotations/polyline/config/toolbar-config';
import RectangleConfig from '../annotations/rectangle/config/toolbar-config';
import SkeletonConfig from '../annotations/skeleton/config/toolbar-config';
import GridToolConfig from '../grid/config/toolbar-config';
import SnapToolConfig from '../snapping/config/toolbar-config';
type ToolConfigT = {
  Icon: (a: {
    strokeColor?: string;
    size?: number;
    title?: string;
  }) => ReactElement;
  title: string;
  hotkey: string;
};
export const TOOL_CONFIG: { [key in ToolT]: ToolConfigT } = {
  [TOOL.POINTER]: {
    Icon: Select,
    title: 'Pointer',
    hotkey: 's'
  },
  [TOOL.RECTANGLE]: RectangleConfig,
  [TOOL.ELLIPSE]: EllipseConfig,
  [TOOL.POLYGON]: PolygonConfig,
  [TOOL.KEY_POINT]: KeyPointConfig,
  [TOOL.POLYLINE]: PolylineConfig,
  [TOOL.CUBOID]: CuboidConfig,
  [TOOL.SEGMENTATION]: BrushConfig,
  [TOOL.GRID]: GridToolConfig,
  [TOOL.SNAP]: SnapToolConfig,
  [TOOL.SKELETON]: SkeletonConfig
};
type CustomToolT = (typeof CUSTOM_TOOLS)[keyof typeof CUSTOM_TOOLS];
export const LABEL_TYPE_CONFIG: { [key in CustomToolT]: Omit<ToolConfigT, 'hotkey'> } = ({
  FRAME_CLASSIFICATION: {
    Icon: FrameClassification,
    title: 'Frame Classification'
  }
} as const);